import { useState, useCallback } from 'react';
import useRecipeV2Api from './useRecipeV2Api';
import { RecipeV2Detail } from '../types';

const useRecipeV2Detail = () => {
  const api = useRecipeV2Api();
  const [recipe, setRecipe] = useState<RecipeV2Detail | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadRecipe = useCallback(async (id: number) => {
    setIsLoading(true);
    setError(null);
    try {
      const detail = await api.getRecipeDetail(id);
      const pricedComponents = (detail.components ?? []).filter(component => component.costPrice != null);
      const derivedCost = pricedComponents.length > 0
        ? pricedComponents.reduce((sum, component) => sum + component.costPrice! * component.quantity, 0)
        : undefined;
      const totalCost = detail.totalCost ?? derivedCost;
      const primaryYield = [...(detail.yields ?? [])].sort((left, right) => left.displayOrder - right.displayOrder)[0];
      setRecipe({
        ...detail,
        totalCost,
        costPerPortion: detail.costPerPortion ?? (totalCost != null && primaryYield?.quantity > 0
          ? totalCost / primaryYield.quantity
          : undefined),
      });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load recipe');
      setRecipe(null);
    } finally {
      setIsLoading(false);
    }
  }, [api]);

  return { recipe, isLoading, error, loadRecipe, setRecipe };
};

export default useRecipeV2Detail;
